export default {
  path: "/info",
  name: "Info",
  component: () => import("../pages/index.vue")
};
